module.exports = __webpack_public_path__ + "static/img/icon_huoyun.111e187a.png";